var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueReported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Issue reported"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 45",
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.0003 59.2042C38.3855 61.608 40.6004 61.5891 42.9856 59.2042L45.9008 56.3082C46.2037 56.0243 46.4687 55.9107 46.8663 55.9107H50.9552C54.3436 55.9107 55.915 54.3586 55.915 50.9515V46.863C55.915 46.4655 56.0286 46.2006 56.3124 45.8977L59.1898 42.9828C61.6129 40.5978 61.5939 38.3832 59.1898 35.9983L56.3124 33.0833C56.0286 32.7994 55.915 32.5155 55.915 32.137V28.0295C55.915 24.6603 54.3627 23.0704 50.9552 23.0704H46.8663C46.4687 23.0704 46.2037 22.9757 45.9008 22.6918L42.9856 19.7958C40.6004 17.3919 38.3855 17.4109 36.0003 19.7958L33.085 22.6918C32.8011 22.9757 32.5171 23.0704 32.1385 23.0704H28.0307C24.6421 23.0704 23.0709 24.6225 23.0709 28.0295V32.137C23.0709 32.5155 22.9763 32.7994 22.6924 33.0833L19.796 35.9983C17.3919 38.3832 17.4108 40.5978 19.796 42.9828L22.6924 45.8977C22.9763 46.2006 23.0709 46.4655 23.0709 46.863V50.9515C23.0709 54.3396 24.6421 55.9107 28.0307 55.9107H32.1385C32.5171 55.9107 32.8011 56.0243 33.085 56.3082L36.0003 59.2042ZM36.3032 49.0209C35.7164 49.0209 35.3378 48.8316 35.0539 48.5098L28.7311 41.4874C28.4661 41.1846 28.3146 40.806 28.3146 40.4085C28.3146 39.5189 28.9962 38.8564 29.9616 38.8564C30.4727 38.8564 30.8513 39.0268 31.192 39.3864L36.2085 44.9324L45.9577 31.2095C46.3363 30.6605 46.7148 30.4334 47.3775 30.4334C48.305 30.4334 48.9676 31.1148 48.9676 32.0045C48.9676 32.3262 48.835 32.7048 48.6268 33.0076L37.5904 48.4341C37.3065 48.7937 36.8712 49.0209 36.3032 49.0209Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueReported);
export default __webpack_public_path__ + "static/media/IssueReported.3ddd11ddc146a73c96cef4a10e056dff.svg";
export { ForwardRef as ReactComponent };